import EdgeTool from '../ButtonDiv/Facet/EdgeTool';
import DrawBtn from '../ButtonDiv/Facet/DrawBtn';
import EditFacet from '../ButtonDiv/Facet/EditFacet';
import DoneBtn from '../ButtonDiv/CreateBtn';

import { BtnWrap, CalculatebtnWrap, EditToolOptionsDiv } from '../style';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import CancelBtn from '../ButtonDiv/Panel/CancelBtn';
import CancelBtnRoofTool from '../ButtonDiv/Facet/CancelBtnRoofTool';
import { selectActiveAction, TOOL_ACTION } from 'store/selectors/toolSelector';
import { ToolCancelButton } from '../ButtonDiv/CancelButton/cancelButton';
import DeleteFacetToggle from '../ButtonDiv/Facet/DeleteFacet/DeleteBtn';
import withPermission from 'components/hoc/withPermission';
import { ALL_ACTIONS } from '../../../../constants';
import KeyboardShortcutsWarningModalRoof from '../KeyboardShortcutsWarningModalRoof/KeyboardShortcutsWarningModalRoof';
import { ToolDoneButton } from '../ButtonDiv/DoneButton/doneButton';

export default function RoofEditorTool() {

	const { activeRoofTool } = useSelector((state: RootState) => state.roofToolLines.data);
	const { deletedRoofIndexes } = useSelector((state: RootState) => state.toolNewPostions.data);

	// const hasUserMadeModificaiton = !!deletedRoofIndexes?.length || !!Object.keys(newlyCreatedFacets)?.length || !!roofIndexes?.length;
	// const showDoneBtnIfUserHasModified = (hasUserMadeModificaiton || drawModeEnabled
	// 	|| deleteObstructionsMode || enableEditFacet || activeRoofTool);
	// const showCanelBtn = editModeEnabled && (drawModeEnabled || deleteObstructionsMode
	// 	|| hadTransition || enableEditFacet);

	const activeAction = useSelector(selectActiveAction);
	
	const modesThatDontNeedDoneButton = [TOOL_ACTION.EDIT_CUSTOM_IMAGE];
	const showDoneButton = (!!activeAction && !modesThatDontNeedDoneButton.includes(activeAction)) || !!deletedRoofIndexes?.length;

	const showCancelButton = !!activeAction && !modesThatDontNeedDoneButton.includes(activeAction);
	const PermittedDrawBtn = withPermission(DrawBtn, ALL_ACTIONS.EDIT_ROOF_SEGMENTS);
	const PermittedEditFacet = withPermission(EditFacet, ALL_ACTIONS.UPDATE_FACETS_COORDS);
	const PermittedEdgeTool = withPermission(EdgeTool, ALL_ACTIONS.UPSERT_ROOF_SEGMENT_EDGES);
	const PermittedDeleteBtn = withPermission(DeleteFacetToggle, ALL_ACTIONS.EDIT_ROOF_SEGMENTS);

	return (
		<>
			<EditToolOptionsDiv>
				<PermittedDrawBtn/>
				<PermittedEditFacet/>
				<PermittedEdgeTool/>
				<PermittedDeleteBtn />
			</EditToolOptionsDiv>
			{(showDoneButton || showCancelButton) && <CalculatebtnWrap>
				{showDoneButton && <BtnWrap><DoneBtn /></BtnWrap>}

				{/* {showDoneButton && <BtnWrap><ToolDoneButton /></BtnWrap>} */}
				{showCancelButton && <ToolCancelButton id="roof-action-cancel"/>}
			</CalculatebtnWrap>}
			<KeyboardShortcutsWarningModalRoof/>
		</>
	);
}
